<template>
    <div class="origin-container">
        <div class="origin-title">
            <span>origin</span>
        </div>
        <div class="origin-content">
            <el-form label-position="top">
                <el-form-item label="（1）Address：">
                    <el-col :span="10">
                        <el-input type="textarea"
                                  :rows=3
                                  @click.native="showDialog('address')"
                                  v-model="addressEN"
                                  placeholder="广州仓库地址：
广州市花都区花山镇启源大道10号中通快递广州分拨"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="（2）Receiver:">
                    <el-col :span="15">
                        <el-input type="textarea"
                                  :rows=3
                                  @click.native="showDialog('receiver')"
                                  v-model="recEN"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="（3）Tel no :">
                    <el-col :span="15">
                        <el-input v-model="tel"></el-input>
                    </el-col>
                </el-form-item>
                <button class="subBtn"
                        @click.prevent="editReceiver">Submit</button>
            </el-form>
        </div>
        <el-dialog title="Multi-Language"
                   :visible.sync="editDialogVisible"
                   :close-on-click-modal="false"
                   width="50%">
            <div class="edit-title">{{tag=='address'?'Address':'Receiver'}}</div>
            <el-form :model="dialogForm"
                     ref="dialogForm">
                <el-form-item label="English"
                              prop="ENDia"
                              :rules="[{required:true,message:tag=='address'?'Address is required':'Receiver is required',pattern: '[^ \x22]+' }]">
                    <el-input type="textarea"
                              v-model="dialogForm.ENDia"
                              :rows=3></el-input>
                </el-form-item>
                <el-form-item label="Chinese"
                              prop="CNDia"
                              :rules="[{required:true,message:tag=='address'?'Address is required':'Receiver is required',pattern: '[^ \x22]+' }]">
                    <el-input type="textarea"
                              v-model="dialogForm.CNDia"
                              :rows=3></el-input>
                </el-form-item>
                <el-form-item label="French"
                              prop="FRDia"
                              :rules="[{required:true,message:tag=='address'?'Address is required':'Receiver is required',pattern: '[^ \x22]+' }]">
                    <el-input type="textarea"
                              v-model="dialogForm.FRDia"
                              :rows=3></el-input>
                </el-form-item>
                 <el-form-item label="Arabic"
                              prop="ARDia"
                              :rules="[{required:true,message:tag=='address'?'Address is required':'Receiver is required',pattern: '[^ \x22]+' }]">
                    <el-input type="textarea"
                              v-model="dialogForm.ARDia"
                              :rows=3></el-input>
                </el-form-item>
                <el-form-item label="Urdu"
                              prop="URDia"
                              :rules="[{required:true,message:tag=='address'?'Address is required':'Receiver is required',pattern: '[^ \x22]+' }]">
                    <el-input type="textarea"
                              v-model="dialogForm.URDia"
                              :rows=3></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="cancelEdit">Cancel</el-button>
                <el-button type="primary"
                           @click="editDialog">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import api from '@api/cooperation'
export default {
    data () {
        return {
            value: '',
            editDialogVisible: false,
            dialogTitle: '',
            addressEN: '',
            addressCN: '',
            addressFR: '',
            addressAR: '',
            addressUR: '',
            recEN: '',
            recCN: '',
            recFR: '',
            recAR: '',
            recUR: '',
            tel: '',
            id: null,
            dialogForm: {
                ENDia: '',
                CNDia: '',
                FRDia: '',
                ARDia: '',
                URDia: '',
            },
            tag: ''
        }
    },
    mounted () {
        this.getReceiver()
    },
    methods: {
        showDialog (tag) {
            this.tag = tag
            if (this.tag == 'address') {
                this.dialogForm.ENDia = this.addressEN
                this.dialogForm.CNDia = this.addressCN
                this.dialogForm.FRDia = this.addressFR
                this.dialogForm.ARDia = this.addressAR
                this.dialogForm.URDia = this.addressUR
            } else {
                this.dialogForm.ENDia = this.recEN
                this.dialogForm.CNDia = this.recCN
                this.dialogForm.FRDia = this.recFR
                this.dialogForm.ARDia = this.recAR
                this.dialogForm.URDia = this.recUR
            }
            this.editDialogVisible = true
        },
        async getReceiver () {
            const res = await api.queryReceiver()
            this.recCN = res.data.receiverCN
            this.recEN = res.data.receiverEN
            this.recFR = res.data.receiverFR
            this.recAR = res.data.receiverAR
            this.recUR = res.data.receiverUR
            this.addressEN = res.data.addressEN
            this.addressCN = res.data.addressCN
            this.addressFR = res.data.addressFR
            this.addressAR = res.data.addressAR
            this.addressUR = res.data.addressUR
            this.tel = res.data.telephone
            this.id = res.data.id
        },
        async editReceiver () {
            let params = {
                addressCN: this.addressCN,
                addressEN: this.addressEN,
                addressFR: this.addressFR,
                addressAR: this.addressAR,
                addressUR: this.addressUR,
                receiverCN: this.recCN,
                receiverEN: this.recEN,
                receiverFR: this.recFR,
                receiverAR: this.recAR,
                receiverUR: this.recUR,
                telephone: this.tel,
                id: this.id
            }
            const res = await api.updateReceiver(params)
            if (res.success == true) {
                this.$message.success('Update successfully!')
                this.getReceiver()
            }
        },
        editDialog () {
            this.$refs.dialogForm.validate(valid => {
                if (valid) {
                    if (this.tag == 'address') {
                        this.addressEN = this.dialogForm.ENDia
                        this.addressCN = this.dialogForm.CNDia
                        this.addressFR = this.dialogForm.FRDia
                        this.addressAR = this.dialogForm.ARDia
                        this.addressUR = this.dialogForm.URDia
                    } else {
                        this.recEN = this.dialogForm.ENDia
                        this.recCN = this.dialogForm.CNDia
                        this.recFR = this.dialogForm.FRDia
                        this.recAR = this.dialogForm.ARDia
                        this.recUR = this.dialogForm.URDia
                    }
                    this.editDialogVisible = false
                    this.$refs.dialogForm.resetFields()

                }
            })
        },
        cancelEdit () {
            this.$refs.dialogForm.resetFields()
            this.editDialogVisible = false

        }
    }
}
</script>
<style scoped>
.origin-container {
    margin-bottom: 20px;
    margin-top: 50px;
    margin-left: 250px;
}
.origin-title {
    padding: 20px;
    font-size: 22px;
    font-weight: 700;
    padding-left: 70px;
}
.origin-content {
    margin-left: 100px;
}
.el-form--label-top >>> .el-form-item__label {
    padding: 0px;
}
.edit-title {
    color: #66b1ff;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
}
.origin-container >>> .el-dialog__header {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #eee;
}
.origin-container >>> .el-dialog__body {
    padding-top: 10px;
}
.origin-container >>> .el-dialog__footer {
    text-align: center;
}
.subBtn {
    border: none;
    width: 130px;
    height: 40px;
    line-height: 40px;
    font-size: 22px;
    color: #fff;
    margin-top: 10px;
    background-color: #fe7b00;
    border-radius: 5px;
    box-shadow: 2px 2px 2px #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/origin.vue